// @flow
import React from 'react';

import {
  FakeItemContainer,
  FakeItemHeader,
  FakeItemTitle,
  FakeItemSubtitle,
  FakeItemFooter,
} from './styled';

type Props = {
  /**
   * Height of the list
   * */
  height: number,
};
/**
 * IssueItemPlaceholder component generate animation while issue loading
 * @version 1.0.0
 * @author [Alexander Hotovshchikov](https://github.com/hotovshchikov)
 */
const IssueItemPlaceholder = ({ height }: Props) => (
  <FakeItemContainer height={height}>
    <FakeItemHeader />
    <FakeItemTitle />
    <FakeItemSubtitle />
    <FakeItemFooter />
  </FakeItemContainer>
);

export default IssueItemPlaceholder;
